import React, { FC } from 'react'
import PlayInScreen from '../../PlayInScreen'
import { mediaType as MediaType } from '@bt-react/constants'
import { PresenterScreenItemProps } from './types'
import WebcamScreen from '../../WebcamScreen'
import SlidesScreen from '../../SlidesScreen'
import ScreenShareScreen from '../../ScreenShareScreen'
import SpotlightScreen from '../../SpotlightScreen'
import StreamScreen from '../../EventStreaming/StreamScreen'
import { OBSERVER } from '../../../dataStore/constants/roles'

const PresenterScreenItem: FC<PresenterScreenItemProps> = ({ mediaType, presenter }) => {

  switch (mediaType) {

    case MediaType.PLAY_IN:
      return <PlayInScreen presenter={presenter} />
    case MediaType.SCREENSHARE:
      return <ScreenShareScreen presenter={presenter} />
    case MediaType.SLIDES:
      return <SlidesScreen presenter={presenter} />
    case MediaType.SPOTLIGHT:
      if(presenter.role !== OBSERVER) {
        return <SpotlightScreen presenter={presenter} />
      }
      return null
    case MediaType.EVENT_STREAM:
      return <StreamScreen />
    case MediaType.WEBCAM:
    default:
      if(presenter.role !== OBSERVER) {
        return <WebcamScreen presenter={presenter} />
      }
      return null

  }

}

export default PresenterScreenItem
